export function UpgradePromotionCard({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="bg-primary relative flex flex-row items-center rounded-lg">
      <div className="flex size-full flex-row items-center gap-2 p-6">
        <div className="text-primary-foreground flex flex-1 flex-col gap-1">
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-sm opacity-80">{description ?? ''}</p>
        </div>
        <div className="flex flex-row gap-2">{actions}</div>
      </div>
    </div>
  );
}
